import React from 'react';

const AirBalloonIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M15 27a2 2 0 0 1-2-2v-2h6v2a2 2 0 0 1-2 2h-2m1-22c.71 0 1.39.09 2.05.26C19.22 6.83 20 9.71 20 13c0 2.28-.38 4.37-1 7a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2c-.62-2.63-1-4.72-1-7 0-3.29.78-6.17 1.95-7.74C14.61 5.09 15.29 5 16 5m8 7c0 3.18-1.85 7.92-4.54 9.21C20.41 19.39 21 15.83 21 13c0-2.83-.59-5.39-1.54-7.21C22.15 7.08 24 8.82 24 12M8 12c0-3.18 1.85-4.92 4.54-6.21C11.59 7.61 11 10.17 11 13s.59 6.39 1.54 8.21C9.85 19.92 8 15.18 8 12z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default AirBalloonIcon;
